import { render, staticRenderFns } from "./StepYesNo.vue?vue&type=template&id=4d398fc4&scoped=true&"
import script from "./StepYesNo.vue?vue&type=script&lang=js&"
export * from "./StepYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d398fc4",
  null
  
)

export default component.exports